import React from 'react'

const FormError: React.FC<{ error?: string }> = ({ error }) => {
  if (!error) return null

  return <div className="form-error">{error}</div>
}

export default FormError
